export const PROFILE_CONNECTION_INIT = "PROFILE_CONNECTION_INIT";
export const PROFILE_CONNECTION_CLOSE = "PROFILE_CONNECTION_CLOSE";
export const PROFILE_CONNECTION_SUCCESS = "PROFILE_CONNECTION_SUCCESS";
export const PROFILE_CONNECTION_CLOSED = "PROFILE_CONNECTION_CLOSED";
export const PROFILE_CONNECTION_ERROR = "PROFILE_CONNECTION_ERROR";
export const PROFILE_GET_MESSAGE = "PROFILE_GET_MESSAGE";

export const profileWsActions = {
  wsInit: PROFILE_CONNECTION_INIT,
  wsClose: PROFILE_CONNECTION_CLOSE,
  onOpen: PROFILE_CONNECTION_SUCCESS,
  onClose: PROFILE_CONNECTION_CLOSED,
  onError: PROFILE_CONNECTION_ERROR,
  onMessage: PROFILE_GET_MESSAGE,
};
